/* istanbul ignore file */
import './kbd.css';

type KbdProps = {
  children: React.ReactNode;
};

export const Kbd = ({ children }: KbdProps) => <span className='kbd'>{children}</span>;
